export default function returnStatusCSS(status, css) {
  switch (status?.toLowerCase()) {
    case 'pending':
      return css.statusYellow;
    case 'sent':
      return css.statusOrange;
    case 'draft':
      return css.statusGrey;
    case 'created':
      return css.statusGrey;
    case 'completed':
      return css.statusGreen;
    case 'cancelled':
      return css.statusGrey;
    case 'error':
      return css.statusRed;
    case 'awaiting wire':
      return css.statusGreen;
    case 'awaiting approval':
      return css.statusGreen;
    case 'requested':
      return css.statusGreen;
  }
}
